// extracted by mini-css-extract-plugin
export default {"imageContainer":"NoResultsOverlay_imageContainer__LQlIY","errorSubheader":"NoResultsOverlay_errorSubheader__dv8N3","errorText":"NoResultsOverlay_errorText__o1qBj"};